// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  type: 'Staging',
  baseHref: '/',
  baseUrl: '',
  cmsUrl: 'https://staging-cms-www.zestmoney.in/data-sharing-consent',
  appUrl: 'https://staging-app.zestmoney.in',
  partnerUrl: 'https://staging-www.zestmoney.in/our-partners/',
  s3BucketUrl: 'https://staging-app.zestmoney.in/staging-merchants-assets',
  loanRestructureBaseUrl: 'https://staging-api.zestmoney.in',
  funnelBaseUrl: 'https://staging-funneltrack.zestmoney.in',
  dummyUuid: '00000000-0000-0000-0000-000000000000',
  featureSwitchBaseUrl: 'https://staging-features.zestmoney.in',
  featureSwtichApi: '14FTv6F6dj94qA3AiTGyEacUKbQRCj0gZT3C0TKe',
  authUrl: 'https://staging-auth.zestmoney.in',
  ekycUrl: 'https://prod.aadhaarbridge.com/api/_init',
  digioUrl: 'https://ext.digio.in:444',
  digio_client_id: 'AIG9OTCD7CNVV2J9HX2EO4D9D3JDY3V2',
  youraccountUrl: 'https://staging-youraccount.zestmoney.in',
  apiGatewayBaseUrl: 'https://staging-api.zestmoney.in',
  lenderUrl: 'https://staging-lender.zestmoney.in',
  whiteListApi: 'YDJN33klTKrbt9pHm12v7H0lVcNViPz58bN1Cqt9',
  staticWebsiteUrl: 'http://staging-www.zestmoney.in',
  billdeskBaseUrl: 'https://uat.billdesk.com',
  boltMyAccountsUrl : 'https://staging-web.zestmoney.in',
  razorpayKey: 'rzp_test_0Mb5mLE9K20hiG',
  googlepayCommsTenantId: '386fa002-fe85-4e5b-9a24-49ac52c63369',
  merchantSettingsApiKey: 'FMCBqgW8Ah59s3x7rokN28GDlXm6YVvS1tG6KGHb',
  kycApiKey: '6AJYYIvslb40yqICpieKp8ZXTOjb5F8TswOPe3hd',
  plMerchantKey : '+w+3FvNqpASauUxai34CiCgdx8QZBHpsyTI1090A+ZN4rc0VfDbPB5j0UwAGdhxz',
  perfiosLinkTenantId: 'f6e3a2c7-9e8f-4042-a472-672eede622ef',
  plDeepLink: 'https://zm-ap.onelink.me/QmPo/home',
  videoKycLinkTenantId: '7845d120-2a95-46ab-9193-c2e40088a6e3',
  // hsbcMerchantId: 'c6be7f95-a2aa-4237-bb77-9953ddefd048',
  hsbcPaymentGatewayId: 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
  // hsbcMerchantKey: '%2BCIi%2Fcc8mtnlbEdMLcxvsML4fuEyx1NvQNWYWIT1pk9P%2BVgu0JBtMNjfkLd60H28',
  partnerCheckoutUrl: ['https://staging-partner.zestmoney.in', 'https://staging-widget.zestmoney.in'],
  utsApiKey: '6AJYYIvslb40yqICpieKp8ZXTOjb5F8TswOPe3hd',
  isUnifiedFlow : true,
  unifiedChannelId : '7b607202-b3c8-11eb-8529-0242ac130003',
  gpayMerchnatID: '3569fe0b-c38d-4a64-9646-d73774f203ee',
  hsbcMerchant: {
    minAmount: 75000,
    maxAmount: 100000,
    corporateName: ['HSBC']
  },
  clIncreaseTenantId: 'd98a2bba-3f89-11eb-b378-0242ac130002',
  experiments: {
    v1: {
      url: 'https://staging-app.zestmoney.in',
      enabled: true
    }
  },
  credentials: [
    {
      client_id: '683c2501-d1a0-43f3-8300-19cd990a1a62',
      grant_type: 'client_credentials',
      scope: 'merchant_api merchant_api_sensitive authentication_users personaldetails_aadhaar_write personaldetails_aadhaar_read addresses_write addresses_liveswith_write addresses_permanent_read addresses_read customerdetails_read customerdetails_write employment_write employment_read obligations_read obligations_write socialdetails_write socialdetails_pan_write socialdetails_read socialdetails_uniq_aadhaar_read comms_mobile_read comms_email_read comms_uniq_mobile_read comms_otp_resend_write comms_otp_verify_write comms_mobile_write comms_email_init_verify_write comms_email_verify_write docs_client_upload_write docs_client_unsignednach_read docs_client_signednach_read aadhaar_kyc_get aadhaar_exists_get bankaccountdetails_write bankaccountdetails_read risk_preapprove_create risk_preapprove_read risk_preapprove_update perfios_read customerdetails_socialdetails_addresses_read customerdetails_employment_obligations_read customerdetails_socialdetails_addresses_write customerdetails_employment_obligations_write personaldetails_customerid_email_from_aadhaar_read preapprove_merchant'
    }
  ],
  concurrency: true,
  enableReferral: false,
  validateIfscCode: true,
  attemptsForAadhaarPan: 3,
  awsUrl: 'https://staging-track.zestmoney.in/clickstream/events',
  payuActionUrl: 'https://test.payu.in/_payment',
  downpaymentMethod: {
    JusPay: true,
    PayU: false
  },
  zestMerchantId: 'a70ce9c4-881a-405d-834a-4a18554fb33a',
  zestMerchantName: 'ZestMoney',
  perfiosIframe: false,
  giftCards: {
    amazonpay: {
      settings: [
        {
          'merchantId': 'd6eb9c55-6690-4525-987c-655a1be59083',
          'minLimit': '1000',
          'maxLimit': '50000',
          'walletId': 'amazongiftcard',
          'denomination': '1'
        }
      ]
    },
    flipkart: {
      settings: [
        {
          'merchantId': 'd1131025-65ba-40ed-90c3-92841e06314b',
          'minLimit': '1000',
          'maxLimit': '50000',
          'walletId': 'flipkartgiftcard',
          'denomination': '1'
        }
      ]
    },
    myntra: {
      settings: [
        {
          'merchantId': '39b74682-334e-462c-8cd3-e67d48b01273',
          'minLimit': '1000',
          'maxLimit': '10000',
          'walletId': 'myntragv',
          'denomination': '1'
        }
      ]
    },
    jabong: {
      settings: [
        {
          'merchantId': '0be981fe-2ca1-4e43-a7aa-b18c1badbb6e',
          'minLimit': '1000',
          'maxLimit': '10000',
          'walletId': 'jabong',
          'denomination': '1',
          'hideMerchant': true
        }
      ]
    },
    pepperfry: {
      settings: [
        {
          'merchantId': '413a26b7-65d9-4e1c-b812-2b75c5d6e478',
          'minLimit': '1000',
          'maxLimit': '50000',
          'walletId': 'pepperfry',
          'denomination': '1',
          'hideMerchant': true
        }
      ]
    },
    uber: {
      settings: [
        {
          'merchantId': '7c648b1c-f28c-4981-a5b7-2f0967040c62',
          'minLimit': '1000',
          'maxLimit': '5000',
          'walletId': 'uber',
          'denomination': '1'
        }
      ]
    },
    bookmyshow: {
      settings: [
        {
          'merchantId': '79119f70-9d1b-44ed-903c-c40969df8b36',
          'minLimit': '1000',
          'maxLimit': '5000',
          'walletId': 'bookmyshow',
          'denomination': '100'
        }
      ]
    },
    lifestyle: {
      settings: [
        {
          'merchantId': 'e9ef9a89-6ce6-4c0e-a497-dcabd5904f88',
          'minLimit': '1000',
          'maxLimit': '50000',
          'walletId': 'lifestyle',
          'denomination': '1',
          'offline': true
        }
      ]
    },
    titan: {
      settings: [
        {
          'merchantId': 'e44651fd-e19e-4f05-92e0-38c58aa40dd9',
          'minLimit': '1000',
          'maxLimit': '25000',
          'walletId': 'titan',
          'denomination': '1',
          'offline': true
        }
      ]
    },
    helios: {
      settings: [
        {
          'merchantId': '800bd9fe-762d-46cd-857e-d1189845d57e',
          'minLimit': '1000',
          'maxLimit': '50000',
          'walletId': 'helios',
          'denomination': '1',
          'offline': true
        }
      ]
    },
  },
  giftCardPartnerList: [
    {
        'merchantId': 'd1131025-65ba-40ed-90c3-92841e06314b',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Flipkart',
        'walletId': 'flipkartgiftcard',
        'minLimit': 1000,
        'maxLimit': 50000,
        'denomination': 1,
        'isActive': true,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': true,
        'order': 1
    },
    {
        'merchantId': 'e9ef9a89-6ce6-4c0e-a497-dcabd5904f88',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'LifeStyle',
        'walletId': 'lifestyle',
        'minLimit': 1000,
        'maxLimit': 50000,
        'denomination': 1,
        'isActive': true,
        'isOffline': true,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 6
    },
    {
        'merchantId': 'e44651fd-e19e-4f05-92e0-38c58aa40dd9',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Titan',
        'walletId': 'titan',
        'minLimit': 1000,
        'maxLimit': 25000,
        'denomination': 1,
        'isActive': true,
        'isOffline': true,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 7
    },
    {
        'merchantId': '413a26b7-65d9-4e1c-b812-2b75c5d6e478',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Pepperfry',
        'walletId': 'pepperfry',
        'minLimit': 1000,
        'maxLimit': 50000,
        'denomination': 1,
        'isActive': false,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 101
    },
    {
        'merchantId': '7c648b1c-f28c-4981-a5b7-2f0967040c62',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Uber',
        'walletId': 'uber',
        'minLimit': 1000,
        'maxLimit': 5000,
        'denomination': 1,
        'isActive': true,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 4
    },
    {
        'merchantId': '79119f70-9d1b-44ed-903c-c40969df8b36',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'BookMyShow',
        'walletId': 'bookmyshow',
        'minLimit': 1000,
        'maxLimit': 5000,
        'denomination': 100,
        'isActive': true,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 5
    },
    {
        'merchantId': 'd6eb9c55-6690-4525-987c-655a1be59083',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'AmazonPay',
        'walletId': 'amazongiftcard',
        'minLimit': 1000,
        'maxLimit': 50000,
        'denomination': 1,
        'isActive': true,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 2
    },
    {
        'merchantId': '0be981fe-2ca1-4e43-a7aa-b18c1badbb6e',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Jabong',
        'walletId': 'jabong',
        'minLimit': 1000,
        'maxLimit': 10000,
        'denomination': 1,
        'isActive': false,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 100
    },
    {
        'merchantId': '39b74682-334e-462c-8cd3-e67d48b01273',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Myntra',
        'walletId': 'myntragv',
        'minLimit': 1000,
        'maxLimit': 10000,
        'denomination': 1,
        'isActive': true,
        'isOffline': false,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 3
    },
    {
        'merchantId': '800bd9fe-762d-46cd-857e-d1189845d57e',
        'paymentGatewayId': 'e39985df-5ac9-4198-897c-94e6ecb9bfec',
        'partnerName': 'Helios',
        'walletId': 'helios',
        'minLimit': 1000,
        'maxLimit': 50000,
        'denomination': 1,
        'isActive': true,
        'isOffline': true,
        'isPayLater': false,
        'isSkipDownpayment': false,
        'order': 8
    }
  ],
  customThemeMerchants: [
    'etmoney', 'mipay', 'micredit', 'googlepay'
  ],
  whiteListUrl: {
    'flipkart': 'http://fkrt.it/fEIM5zuuuN',
    'amazonpay': 'https://www.amazon.in/?&_encoding=UTF8&tag=zestmoney-21&linkCode=ur2&linkId=9577f7adc0716e5a8b2c7d4336468f19&camp=3638&creative=24630'
  },
  offlineCustomMerchants: {
    vedantuMerchantId: '4a13ba3b-d79e-45b6-8cb5-df5c63d37e3d',
    uncademyMerchantId: '49c6f43b-7180-4333-8b12-6bd9c4895b3e'
  },
};
